import {
  EcommerceProductsAction,
  LOAD_ECOMMERCE_CUSTOMER, LOAD_ECOMMERCE_CUSTOMER_FAIL, LOAD_ECOMMERCE_CUSTOMER_SUCCESS,
  LOAD_ECOMMERCE_CUSTOMERS,
  LOAD_ECOMMERCE_CUSTOMERS_FAIL,
  LOAD_ECOMMERCE_CUSTOMERS_SUCCESS, LoadEcommerceCustomerFails,
  LoadEcommerceCustomersFails,
  LoadEcommerceCustomersSuccess, LoadEcommerceCustomerSuccess
} from "../actions";
import {IOrder} from "../../websites/website/ecommerce/orders/orders.interface";
import {ICustomer} from "../../websites/website/ecommerce/ecommerce-customer.interface";
import {ICustomerViewData} from "../../websites/website/ecommerce/customers/customer-view/customer-view.interface";

export interface IEcommerceCustomersEntityState {
  orders: IOrder[];
  customers: ICustomer[];
  customer: ICustomerViewData;
  customersCount: number;
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

export interface IEcommerceCustomersState {
  entities: { [websiteId: number]: IEcommerceCustomersEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceCustomersState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceCustomersState = initialState, action: EcommerceProductsAction): IEcommerceCustomersState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_CUSTOMERS:
      payload = (<LoadEcommerceCustomersSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_CUSTOMERS_SUCCESS:
      payload = (<LoadEcommerceCustomersSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            orders: payload.entities.orders,
            customers: payload.entities.customers,
            customersCount: payload.customersCount,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_CUSTOMERS_FAIL:
      payload = (<LoadEcommerceCustomersFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_CUSTOMER:
      payload = (<LoadEcommerceCustomerSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_CUSTOMER_SUCCESS:
      payload = (<LoadEcommerceCustomerSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            customer: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_CUSTOMER_FAIL:
      payload = (<LoadEcommerceCustomerFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true,
            failed: true
          }
        }
      };
  }

  return state;
}
